import React from 'react'
import { Button, Modal } from 'react-bootstrap';
import { db } from "../config/firebase";
import { doc, updateDoc, arrayRemove } from "firebase/firestore";

function ProfileDeleteCourseModal({ user, userData, setUserData, courseToDelete, showDeleteCourseModal, setShowDeleteCourseModal, refreshUserData }) {

    const handleCancel = () => {
        setShowDeleteCourseModal(false);
    }

    const handleRemoveCourse = async () => {
        console.log('Trying to delete Course:', courseToDelete);
        try {
            const userRef = doc(db, "users", user.uid);
            await updateDoc(userRef, {
                courses: arrayRemove({
                    course: courseToDelete.course,
                    group: courseToDelete.group
                })
            });
            console.log("course removed successfully!");
            setShowDeleteCourseModal(false);
            refreshUserData();
        } catch (error) {
            console.log("Error deleting course: ", error);
        }
    }

    return (
        <div className="modalContainer">
            <Modal id="confirmReservationModal" centered show={showDeleteCourseModal} onHide={handleCancel} backdrop="static" className="text-center">
                <Modal.Header className="text-center d-block ">
                    <Modal.Title>Remove Course From Profile</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Confirm you want to remove <strong>{courseToDelete?.name}</strong> from your list of courses using the button below.</p>
                </Modal.Body>
                <Modal.Footer className="footerButtons">
                    <Button variant="danger" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleRemoveCourse}>
                        Remove Course
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ProfileDeleteCourseModal;